import { render, staticRenderFns } from "./ApplicantEditResubmissions.vue?vue&type=template&id=629187a6&"
import script from "./ApplicantEditResubmissions.vue?vue&type=script&lang=js&"
export * from "./ApplicantEditResubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports